import { getCookie } from '@/resources/utils'

export const isAuthenticated = () => !!getCookie('is_authenticated')

export const getAccessToken = () => getCookie('seu_ze_access_token')
